import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/App";
import { LayoutDashboard, Wallet, Users, User, ShoppingBag } from "lucide-react";
import { PanelShell } from "./PanelShell";
import { NotificationBell } from "@/components/site/NotificationBell";

const MENU = [
  { icon: LayoutDashboard, label: "Dashboard", path: "/dashboard" },
  { icon: Wallet, label: "Wallet", path: "/wallet" },
  { icon: Users, label: "Referrals", path: "/referrals" },
  { icon: User, label: "Profile", path: "/profile" },
];

const UserLayout = ({ children, title }) => {
  const { user } = useAuth();
  return (
    <PanelShell
      badge="My Account"
      menuItems={MENU}
      testIdFor={(i) => `nav-${i.label.toLowerCase()}`}
      logoutTestId="logout-btn"
      title={title}
      headerRight={
        <>
          <Link to="/products" className="hidden sm:inline-flex items-center h-10 px-4 rounded-full bg-white/15 hover:bg-white/25 text-white text-sm font-semibold" data-testid="browse-deals-link">
            <ShoppingBag className="w-4 h-4 mr-2" />Browse deals
          </Link>
          <NotificationBell />
          <span className="hidden md:block text-sm text-primary-100 truncate max-w-[160px]">Hi, <strong className="text-white">{user?.name}</strong></span>
        </>
      }
    >
      {children}
    </PanelShell>
  );
};

export default UserLayout;
